import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { DeliveryAward } from '../all-awards-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<DeliveryAward, unknown>[] = [
		buildColumn(util, 'Id', row => row.awardId, { header: 'awardId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'Accelerator' }),
		buildColumn(util, 'Text', row => row.language, { header: 'Language' }),
		buildColumn(util, 'Text', row => row.facilitatorName, { header: 'Facilitator Name' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name' }),
		buildColumn(util, 'Text', row => row.entrepreneurs.map(e => e.name).join(', '), { header: 'Awardees' }),
		buildColumn(util, 'Text', row => row.awardName, { header: 'Award Name' }),
		buildColumn(util, 'Dollar', row => row.value, { header: 'Award $ Amount' }),
		buildColumn(util, 'Text', row => row.awardKind, { header: 'Award Kind' }),
		buildColumn(util, 'Email', row => row.entrepreneurs.map(e => e.email).join(', '), { header: 'Entrepreneur Email(s)' }),
		buildColumn(util, 'FullName', row => row.entrepreneurs[0]?.name, { header: `Entrepreneur 1 Name` }),
		buildColumn(util, 'Email', row => row.entrepreneurs[0]?.email, { header: `Entrepreneur 1 Email` }),
		buildColumn(util, 'Phone', row => row.entrepreneurs[0]?.phone, { header: `Entrepreneur 1 Phone` }),
		buildColumn(util, 'Text', row => row.entrepreneurs[0]?.location, { header: `Entrepreneur 1 Location` }),
		buildColumn(util, 'FullName', row => row.entrepreneurs[1]?.name, { header: `Entrepreneur 2 Name` }),
		buildColumn(util, 'Email', row => row.entrepreneurs[1]?.email, { header: `Entrepreneur 2 Email` }),
		buildColumn(util, 'Phone', row => row.entrepreneurs[1]?.phone, { header: `Entrepreneur 2 Phone` }),
		buildColumn(util, 'Text', row => row.entrepreneurs[1]?.location, { header: `Entrepreneur 2 Location` })
	];


	return columns;

}